<template>
  <page-view>
    <sixteen-wide-column>
      <h1>Frequently Asked Questions</h1>
      <accordion></accordion>
    </sixteen-wide-column>
  </page-view>
</template>

<script>
import SixteenWideColumn from "../components/utility/SixteenWideColumn";
import Accordion from "../components/Accordion.vue";

export default {
  name: "FrequentlyAskedQuestions",
  components: { SixteenWideColumn, Accordion }
};
</script>

<style scoped>
</style>
